import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { map, Observable, takeLast, takeWhile, timer } from 'rxjs';

import { State } from '../../core/state';

@Component({
  selector: 'black-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.css',
  standalone: false,
  host: {
    ngSkipHydration: 'true',
  },
})
export class VerifyOtpComponent implements OnInit, AfterViewInit {
  private fb = inject(NonNullableFormBuilder);
  private store = inject<Store<State>>(Store);

  otpForm: FormGroup;
  otpError: string | null = null;

  @Input()
  username: string | undefined = undefined;

  @Input()
  sendCodeOnInit = true;

  @Output()
  otpReady = new EventEmitter<{ code: string }>();

  @Output()
  sendCodeEvent = new EventEmitter<void>();

  constructor() {
    this.otpForm = this.fb.group({
      otp: [''],
    });
  }

  resendEnable = false;

  timeRemaining$ = new Observable<number>();

  ngAfterViewInit(): void {
    this.store
      .select((state) => state.users.otp)
      .subscribe((otp) => {
        if (otp.expiresOn) {
          this.resendEnable = false;

          const leftTime =
            (otp.expiresOn.getTime() - new Date().getTime()) / 1000;

          this.timeRemaining$ = timer(0, 1000).pipe(
            map((n) => (leftTime - n) * 1000),
            takeWhile((n) => n >= 0)
          );

          this.timeRemaining$.pipe(takeLast(1)).subscribe(() => {
            this.resendEnable = true;
          });
        }
      });
  }

  sendCode = () => {
    if (this.sendCodeEvent) {
      this.sendCodeEvent.emit();
      return;
    }
  };

  ngOnInit(): void {
    this.store
      .select((state) => state.users.error)
      .subscribe((msg) => {
        this.otpError = msg;
      });

    if (this.sendCodeOnInit) {
      this.sendCode();
    }
  }

  get otpLength() {
    return this.otpForm.get('otp')?.value.length;
  }

  get otpValue() {
    return this.otpForm.get('otp')?.value;
  }

  submit() {
    if (this.otpValue) {
      this.otpReady.emit({ code: this.otpValue });
    }
  }
}
